import {
  FETCH_ASSISTANTURL_REQUEST,
  FETCH_ASSISTANTURL_SUCCESS,
  FETCH_ASSISTANTURL_ERROR,
  HANDLE_ASSISTANT_AUTHENTICATION_FAILURE,
  ASSISTANT_NAVIGATION_REQUEST,
  ASSISTANT_NAVIGATION_SUCCESS,
  ASSISTANT_NAVIGATION_CLEAR,
  DRUG_NAVIGATION_FALLBACK_PATH,
  DRUG_NAVIGATION_FALLBACK_TYPE
} from "./constants";
import apiService from "../../utils/ApiService";
import logAssistantFailure from "./logAssistantFailure";
import {
  logAssistantInitiated,
  logAssistantNavigateClicked
} from "../../utils/analytics";

export const navigateAssistantRequest = () => ({
  type: ASSISTANT_NAVIGATION_REQUEST
});

export const navigateAssistantSuccess = (payload) => ({
  type: ASSISTANT_NAVIGATION_SUCCESS,
  payload
});

export const navigateAssistantClear = () => ({
  type: ASSISTANT_NAVIGATION_CLEAR
});

export const fetchAssistantUrl = async (dispatch, pathname) => {
  dispatch({ type: FETCH_ASSISTANTURL_REQUEST });
  logAssistantInitiated(pathname);
  try {
    const response = await apiService.getAssistantUrl();
    dispatch({
      type: FETCH_ASSISTANTURL_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    logAssistantFailure(error);
    dispatch({
      type: FETCH_ASSISTANTURL_ERROR
    });
  }
};

export const handleAssistantAuthenticationFailure = (dispatch) => {
  logAssistantFailure(
    new Error("Received authentication failure message from Assistant")
  );
  dispatch({ type: HANDLE_ASSISTANT_AUTHENTICATION_FAILURE });
};

//TODO: setAssistantNavigationData is not used with removal of chatbot,
//clean up after feature is released
export const setAssistantNavigationData = async (dispatch, eventData) => {
  dispatch(navigateAssistantRequest());
  const externalId = eventData.indepthAnswersDocId;
  logAssistantNavigateClicked(eventData.navType);
  if (externalId) {
    try {
      const response = await apiService.getDrugSlug(externalId);
      if (response?.data?.slug) {
        return dispatch(
          navigateAssistantSuccess({
            basePath: response.data.slug,
            sectionKey: eventData.sectionKey,
            type: eventData.navType
          })
        );
      } else {
        return dispatch(
          navigateAssistantSuccess({
            basePath: DRUG_NAVIGATION_FALLBACK_PATH,
            title: eventData.title,
            sectionKey: eventData.sectionKey,
            type: DRUG_NAVIGATION_FALLBACK_TYPE
          })
        );
      }
    } catch (err) {
      logAssistantFailure(
        new Error(
          `Failed during call to retrieve slug for assistant navigation event: ${eventData} with error: ${err}`
        )
      );
      return dispatch(
        navigateAssistantSuccess({
          basePath: DRUG_NAVIGATION_FALLBACK_PATH,
          title: eventData.title,
          sectionKey: eventData.sectionKey,
          type: DRUG_NAVIGATION_FALLBACK_TYPE
        })
      );
    }
  } else {
    return dispatch(
      navigateAssistantSuccess({
        basePath: DRUG_NAVIGATION_FALLBACK_PATH,
        title: eventData.title,
        sectionKey: eventData.sectionKey,
        type: DRUG_NAVIGATION_FALLBACK_TYPE
      })
    );
  }
};
